import React, { Component } from "react";
import ReactTimeout from "react-timeout";
import Emitter from "./components/Services/EventEmitter";

import { Router, Switch, Route, Redirect } from "react-router-dom";

import { createBrowserHistory as createHistory } from "history";

//Layouts

import AuthLayout from "../src/components/Layouts/AuthLayout";
import StaticLayout from "../src/components/Layouts/StaticLayout";
import UserLayout from "../src/components/Layouts/UserLayout";
import EmptyLayout from "../src/components/Layouts/EmptyLayout";

// Auth Layout
import RegisterComponent from "../src/components/Auth/Register";
import LoginCommponent from "../src/components/Auth/Login";
import ForgotPasswordComponent from "../src/components/Auth/ForgotPassword";
import ResetPasswordComponent from "../src/components/Auth/ResetPassword";
import LatestLandingPage from "../src/components/LatestLandingPage/LatestLandingPage";
import OrganizationPublicPage from "../src/components/Organization/Public/OrganizationPublicPage";
import CreatorPublicPage from "../src/components/Creator/Public/CreatorPublicPage";
import ProjectPublicPage from "./components/Project/Public/ProjectPublicPage";
import FiftyFiftyEventPage from "./components/FiftyFifty/FiftyFiftyEventPage";
import ReverseRaffleEventPage from "./components/ReverseRaffle/ReverseRaffleEventPage";
import FilmFestivalPage from "./components/FilmFestival/FilmFestivalPage";
import PlatformLaunchPage from "./components/Platforms/PlatformLaunchPage";
import CommunityPlaceholderPage from "./components/Community/CommunityPlaceholderPage";
import CommunityLandingPage from "./components/Community/CommunityLandingPage";
import GamesLandingPage from "./components/Games/GamesLandingPage";
import GamePlayPage from "./components/Games/GamePlayPage";
//Empty layout
import Sample from "../src/components/Static/Sample";
import ErrorComponent from "../src/components/Static/Error";
import FrontendHealthPage from "./components/Static/FrontendHealthPage";
import ViewProfilesComponent from "../src/components/User/Account/ViewProfiles";
import ManageProfilesComponent from "../src/components/User/Account/ManageProfiles";
import EditProfilesComponent from "../src/components/User/Account/Editprofile";
import LoaderComponent from "./components/Static/Loader";
import PlaybackEntry from "./video-player/production/PlaybackEntry";
import PlayerLabPage from "./video-player/lab/PlayerLabPage";
import EmbedPlaybackPage from "./video-player/production/EmbedPlaybackPage";
import TimelineStudioPage from "./components/Broadcast/TimelineStudioPage";
import EpgPage from "./components/Broadcast/EpgPage";
import BroadcastOpsPage from "./components/Broadcast/BroadcastOpsPage";
import ChannelTunePage from "./components/Broadcast/ChannelTunePage";
import ChannelDirectoryPage from "./components/Broadcast/ChannelDirectoryPage";
import ChannelDetailPage from "./components/Content/ChannelDetailPage";
import GuidePage from "./components/Content/GuidePage";
import SchedulerAdminRedirect from "./components/Scheduler/SchedulerAdminRedirect";
import CreatorStudioPage from "./components/ContentStudio/CreatorStudioPage";
import OrganizationStudioPage from "./components/ContentStudio/OrganizationStudioPage";
import ProjectStudioPage from "./components/ContentStudio/ProjectStudioPage";
import StudioLandingPage from "./components/ContentStudio/StudioLandingPage";
import MediaLibraryPage from "./components/ContentStudio/MediaLibraryPage";
import {
  PersonalWorkspacePage,
  CreatorWorkspacePage,
  OrganizationWorkspacePage,
  ProjectWorkspacePage,
  SalesWorkspacePage,
  ModeratorWorkspacePage,
  SubadminWorkspacePage,
  AdvertiserWorkspacePage,
  PartnerWorkspacePage,
  WorkspaceHomePage,
} from "./components/Workspace/WorkspacePages";
import AdvertisingAdminRedirect from "./components/Advertising/AdvertisingAdminRedirect";
import EntityDonatePage from "./components/Donate/EntityDonatePage";
import DonateThankYouPage from "./components/Donate/DonateThankYouPage";
import DonatePageEntry from "./components/Donate/DonatePageEntry";
import DonateFeature from "./components/Donate/DonateFeature";
import {
  OrganizationLandingPage,
  CreatorLandingPage,
  ProjectLandingPage,
} from "./components/Applications/ApplicationLandingPage";
import {
  OrganizationApplyPage,
  CreatorApplyPage,
  ProjectApplyPage,
} from "./components/Applications/ApplicationFormPage";
import ApplicationSuccessPage from "./components/Applications/ApplicationSuccessPage";
import ApplicationsAdminPage from "./components/Applications/ApplicationsAdminPage";

// User Layout
import Home from "../src/components/User/Home";
import AccountComponent from "../src/components/User/Account/Account";
import EditAccountComponent from "../src/components/User/Account/EditAccount";
import ChangePasswordComponent from "../src/components/User/Account/ChangePassword";
import ReferalFriend from "../src/components/Referal/ReferalFriend";
import DeleteAccountComponent from "../src/components/User/Account/DeleteAccount";
import SearchComponent from "./components/User/Search";

import SubscriptionComponent from "../src/components/User/Settings/Subscription";
import BillingDetailsComponent from "../src/components/User/Settings/BillingDetails";
import BillingDetailsView from "../src/components/User/Settings/billing-view-details";
import AddCardComponent from "../src/components/User/Settings/AddCard";
import CardDetailsComponent from "../src/components/User/Settings/CardDetails";
import InvoiceComponent from "../src/components/User/Settings/Invoice";
import PayPerView from "../src/components/User/Settings/PayPerView";
import PaymentHistory from "../src/components/User/Settings/PaymentHistory";
import PaymentViewDetails from "../src/components/User/Settings/payment-view-details";
import PaymentOptions from "../src/components/User/Settings/PaymentOptions";
import PaymentSuccess from "../src/components/User/Settings/PaymentSuccess";
import PaymentFailure from "../src/components/User/Settings/PaymentFailure";
import SubCategory from "../src/components/User/Video/SubCategory";
import Logout from "./components/Auth/logout";

// Static layout
import Page from "../src/components/Static/Page";
import LegalDocumentPage from "../src/components/Legal/LegalDocumentPage";
import Wishlist from "./components/User/Account/wishlist";
import History from "./components/User/Account/history";
import { Elements, StripeProvider } from "react-stripe-elements";

import { ToastProvider } from "react-toast-notifications";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Genres from "./components/User/genres";
import Category from "./components/User/category";
import ViewAll from "./components/User/viewAll";
import Notifications from "./components/User/Account/notificationsViewAll";
import PublicBrowseGate from "./components/Helper/PublicBrowseGate";
import KidsVisibilityGate from "./components/Helper/KidsVisibilityGate";
import CastCrewDetail from "./components/User/castCrewDetail";
import ShopVisibilityGate from "./components/Helper/ShopVisibilityGate";
import { withStudioCapability } from "./components/Helper/StudioCapabilityGate";
import ShopReserved from "./components/Shop/ShopReserved";
import ShopProductDetail from "./components/Shop/ShopProductDetail";
import CartPage from "./components/Commerce/CartPage";
import CheckoutPage from "./components/Commerce/CheckoutPage";
import OrderPage from "./components/Commerce/OrderPage";

import configuration from "react-global-configuration";
import { apiConstants } from "./components/Constant/constants";
import { applyAppearanceTheme } from "./components/Helper/appearance";
import configData from "./json/settings.json";
import { Helmet } from "react-helmet";
import ExperiencePlatformGate from "./components/Experience/ExperiencePlatformGate";
import {
  getPlatformExperienceFromSettings,
  syncAnonymousExperienceStateAfterLogin,
} from "./components/Experience/experienceHelpers";
import {
  loadAuthConfig,
  getGooglePublicClientId,
} from "./auth/authConfigService";

import {
  setTranslations,
  setDefaultLanguage,
  translate,
  setLanguage,
} from "react-multi-lang";
import en from "./components/translation/en.json";
import pt from "./components/translation/pt.json";
import MetaTags from 'react-meta-tags';

setTranslations({ pt, en });

const history = createHistory();
const $ = window.$;

const AppRoute = ({
  component: Component,
  layout: Layout,
  screenProps: ScreenProps,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => (
      <Layout screenProps={ScreenProps}>
        <Component {...props} />
      </Layout>
    )}
  />
);

const PrivateRoute = ({
  component: Component,
  layout: Layout,
  screenProps: ScreenProps,
  authentication,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      authentication === true ? (
        <Layout screenProps={ScreenProps}>
          <Component {...props} />
        </Layout>
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);

class App extends Component {
  constructor(props) {
    super(props);

    let userId = localStorage.getItem("userId");

    let accessToken = localStorage.getItem("accessToken");

    this.state = {
      loading: true,
      configLoading: true,
      authentication: userId && accessToken ? true : false,
      platformExperience: null,
      googleClientId: "",
      adsenseVerificationMeta: "",
    };

    this.eventEmitter = new Emitter();

    history.listen((location, action) => {
      userId = localStorage.getItem("userId");

      accessToken = localStorage.getItem("accessToken");

      this.setState({
        loading: true,
        authentication: userId && accessToken ? true : false,
      });

      // this.setState({ loading: true, authentication: true });

      // this.loadingFn();

      document.body.scrollTop = 0;
    });
    this.fetchConfig();

    // document.oncontextmenu = function(e) {
    //   console.log(e.button);
    //   if (e.button == 2) {
    //     e.preventDefault();
    //     return false;
    //   }
    // };
  }

  async fetchConfig() {
    const settingsPromise = fetch(apiConstants.settingsUrl).then(function (
      response
    ) {
      return response.json();
    });

    // Prefer Authentication Framework; fall back to settings social_logins.
    await loadAuthConfig({ force: false }).catch(function () {
      return null;
    });

    const configValue = await settingsPromise;
    configuration.set({
      configData: configValue.data,
    });
    applyAppearanceTheme(
      configValue.data && configValue.data.appearance
        ? configValue.data.appearance
        : null
    );
    this.setState({
      configLoading: false,
      platformExperience: getPlatformExperienceFromSettings(),
      googleClientId: getGooglePublicClientId(),
    });

    if (localStorage.getItem("userId") && localStorage.getItem("accessToken")) {
      syncAnonymousExperienceStateAfterLogin();
    }

    $("#google_analytics").html(
      configuration.get("configData.google_analytics")
    );

    $("#header_scripts").html(configuration.get("configData.header_scripts"));

    $("#body_scripts").html(configuration.get("configData.body_scripts"));

    // Google AdSense — append network script without replacing site header_scripts.
    // Integrates with advertising bootstrap from Sprint advertising platform (placements untouched).
    try {
      var adsense =
        (configValue.data &&
          configValue.data.advertising &&
          configValue.data.advertising.adsense) ||
        null;
      var existingAdsense = document.getElementById("tpg-adsense-script");
      if (existingAdsense && existingAdsense.parentNode) {
        existingAdsense.parentNode.removeChild(existingAdsense);
      }
      // Do not inject the loader twice: the deploy step may already bake a
      // crawler-visible adsbygoogle loader into the static index.html <head>.
      var staticAdsenseLoader = document.querySelector(
        'script[src*="adsbygoogle.js"]'
      );
      if (
        adsense &&
        adsense.enabled &&
        adsense.header_script &&
        !staticAdsenseLoader
      ) {
        var holder = document.createElement("span");
        holder.id = "tpg-adsense-script";
        holder.innerHTML = adsense.header_script;
        var headerTarget = document.getElementById("header_scripts");
        if (headerTarget) {
          headerTarget.appendChild(holder);
        }
      }
      // AdSense site verification uses the google-adsense-account meta (NOT
      // google-site-verification, which is Search Console). The authoritative,
      // crawler-visible tag is baked into static index.html at deploy time; only
      // render a client-side fallback when that static tag is absent, to avoid
      // duplicate meta tags.
      var staticAdsenseMeta = document.querySelector(
        'meta[name="google-adsense-account"]'
      );
      this.setState({
        adsenseVerificationMeta:
          adsense &&
          adsense.enabled &&
          adsense.verification_meta &&
          !staticAdsenseMeta
            ? adsense.verification_meta
            : "",
      });
    } catch (e) {
      // Non-fatal — advertising bootstrap must not block app boot
    }
  }

  loadingFn() {
    this.props.setTimeout(() => {
      this.setState({ loading: false });
    }, 3 * 1000);
  }

  componentDidMount() {
    let userLanguage = localStorage.getItem("lang")
      ? localStorage.getItem("lang")
      : "en";
    // console.log(userLanguage);
    localStorage.setItem("lang", userLanguage);
    setLanguage(userLanguage);
    // console.log("Google", configuration.get("configData"));
  }

  render() {
    const isLoading = this.state.configLoading;

    if (isLoading) {
      return (
        <div className="wrapper">
          <div className="loader-warpper">
            <div id="loader">{/* <p>Project setting up</p> */}</div>
          </div>
        </div>
      );
    }

    const googleClientId =
      this.state.googleClientId || getGooglePublicClientId() || "";

    const appRouter = (
      <Router history={history}>
        <ExperiencePlatformGate presentation={this.state.platformExperience}>
        <Switch>
                {/*** Public Applications landings + forms (exact index before :slug) ****/}
                <AppRoute
                  exact
                  path={"/organizations/apply"}
                  component={OrganizationApplyPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/creators/apply"}
                  component={CreatorApplyPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/projects/apply"}
                  component={ProjectApplyPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/organizations"}
                  component={OrganizationLandingPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/creators"}
                  component={CreatorLandingPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/projects"}
                  component={ProjectLandingPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/apply/success"}
                  component={ApplicationSuccessPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                {/*** Organization / Creator / Project — canonical public + donation hierarchy ****/}
                <AppRoute
                  exact
                  path={"/organization/:slug/donate/thank-you"}
                  component={DonateThankYouPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/organization/:slug/donate/checkout"}
                  component={DonateFeature}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/organization/:slug/donate"}
                  component={EntityDonatePage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/organization/:slug"}
                  component={OrganizationPublicPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                {/* Plural + /org aliases permanently redirect to singular canonical paths */}
                <Route
                  exact
                  path={"/organizations/:slug/donate/thank-you"}
                  render={(props) => (
                    <Redirect
                      to={`/organization/${props.match.params.slug}/donate/thank-you`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/organizations/:slug/donate/checkout"}
                  render={(props) => (
                    <Redirect
                      to={`/organization/${props.match.params.slug}/donate/checkout`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/organizations/:slug/donate"}
                  render={(props) => (
                    <Redirect
                      to={`/organization/${props.match.params.slug}/donate`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/organizations/:slug"}
                  render={(props) => (
                    <Redirect
                      to={`/organization/${props.match.params.slug}`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/org/:slug/donate/thank-you"}
                  render={(props) => (
                    <Redirect
                      to={`/organization/${props.match.params.slug}/donate/thank-you`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/org/:slug/donate/checkout"}
                  render={(props) => (
                    <Redirect
                      to={`/organization/${props.match.params.slug}/donate/checkout`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/org/:slug/donate"}
                  render={(props) => (
                    <Redirect
                      to={`/organization/${props.match.params.slug}/donate`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/org/:slug"}
                  render={(props) => (
                    <Redirect
                      to={`/organization/${props.match.params.slug}`}
                    />
                  )}
                />

                <AppRoute
                  exact
                  path={"/creator/:slug/donate/thank-you"}
                  component={DonateThankYouPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/creator/:slug/donate/checkout"}
                  component={DonateFeature}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/creator/:slug/donate"}
                  component={EntityDonatePage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/creator/:slug"}
                  component={CreatorPublicPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <Route
                  exact
                  path={"/creators/:slug/donate/thank-you"}
                  render={(props) => (
                    <Redirect
                      to={`/creator/${props.match.params.slug}/donate/thank-you`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/creators/:slug/donate/checkout"}
                  render={(props) => (
                    <Redirect
                      to={`/creator/${props.match.params.slug}/donate/checkout`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/creators/:slug/donate"}
                  render={(props) => (
                    <Redirect
                      to={`/creator/${props.match.params.slug}/donate`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/creators/:slug"}
                  render={(props) => (
                    <Redirect to={`/creator/${props.match.params.slug}`} />
                  )}
                />

                <AppRoute
                  exact
                  path={"/project/:slug/donate/thank-you"}
                  component={DonateThankYouPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/project/:slug/donate/checkout"}
                  component={DonateFeature}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/project/:slug/donate"}
                  component={EntityDonatePage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/project/:slug"}
                  component={ProjectPublicPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <Route
                  exact
                  path={"/projects/:slug/donate/thank-you"}
                  render={(props) => (
                    <Redirect
                      to={`/project/${props.match.params.slug}/donate/thank-you`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/projects/:slug/donate/checkout"}
                  render={(props) => (
                    <Redirect
                      to={`/project/${props.match.params.slug}/donate/checkout`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/projects/:slug/donate"}
                  render={(props) => (
                    <Redirect
                      to={`/project/${props.match.params.slug}/donate`}
                    />
                  )}
                />
                <Route
                  exact
                  path={"/projects/:slug"}
                  render={(props) => (
                    <Redirect to={`/project/${props.match.params.slug}`} />
                  )}
                />

                <Route exact path={"/old-landing-page"}>
                  <Redirect to="/" />
                </Route>

                {/***Auth layout - Having only footer ****/}
                <AppRoute
                  exact
                  path={"/"}
                  component={LatestLandingPage}
                  layout={AuthLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path={"/register"}
                  component={RegisterComponent}
                  layout={AuthLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path={"/login"}
                  component={LoginCommponent}
                  layout={AuthLayout}
                  screenProps={this.eventEmitter}
                />
                {/* Preferred portal short paths (Phase A RC1) — SPA surfaces */}
                <Route exact path="/creator" render={() => <Redirect to="/studio" />} />
                <Route exact path="/creator/login" render={() => <Redirect to="/login" />} />
                <Route exact path="/organization" render={() => <Redirect to="/studio" />} />
                <Route exact path="/organization/login" render={() => <Redirect to="/login" />} />
                <Route exact path="/project" render={() => <Redirect to="/studio" />} />
                <Route exact path="/project/login" render={() => <Redirect to="/login" />} />
                <Route path={"/logout"} component={Logout} />
                <AppRoute
                  path={"/forgot-password"}
                  component={ForgotPasswordComponent}
                  layout={AuthLayout}
                  screenProps={this.eventEmitter}
                />

                <AppRoute
                  path={"/reset-password/:token"}
                  component={ResetPasswordComponent}
                  layout={AuthLayout}
                  screenProps={this.eventEmitter}
                />

                {/* exact: keep Series/Movies from prefix-matching nested paths;
                    Genres is shared — identity reload lives in genres.jsx. */}
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/series"}
                  component={Genres}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/movies"}
                  component={Genres}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/kids"}
                  exact
                  component={(props) => (
                    <KidsVisibilityGate>
                      <Genres {...props} />
                    </KidsVisibilityGate>
                  )}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                {/* Platform Availability — UserHeader nav; ahead of /:publicSlug. */}
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/organizations/:slug/platforms"}
                  component={PlatformLaunchPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/platforms"}
                  component={PlatformLaunchPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                {/* A-009A.3 — Community hub + dynamic section pages; ahead of /:publicSlug. */}
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/community"}
                  component={CommunityLandingPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                {/* Community → Games; ahead of /:publicSlug. */}
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/games"}
                  component={GamesLandingPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/games/:slug"}
                  component={GamePlayPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/community/:slug"}
                  component={CommunityPlaceholderPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                {/* Reserved commerce route — must stay ahead of /:publicSlug. */}
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/shop/product/:slug"}
                  component={(props) => (
                    <ShopVisibilityGate>
                      <ShopProductDetail {...props} />
                    </ShopVisibilityGate>
                  )}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/shop"}
                  component={(props) => (
                    <ShopVisibilityGate>
                      <ShopReserved {...props} />
                    </ShopVisibilityGate>
                  )}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/cart"}
                  component={CartPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/checkout"}
                  component={(props) => (
                    <StripeProvider
                      apiKey={configuration.get(
                        "configData.stripe_publishable_key"
                      )}
                    >
                      <Elements>
                        <CheckoutPage {...props} />
                      </Elements>
                    </StripeProvider>
                  )}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/order/:number"}
                  component={OrderPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/genre/:id"}
                  component={Genres}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/view-all"}
                  component={ViewAll}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/cast-crew/:id"}
                  component={CastCrewDetail}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/notification/view-all"}
                  component={Notifications}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                {/***Empty layout ****/}
                <AppRoute
                  path={"/sample"}
                  component={Sample}
                  layout={EmptyLayout}
                  screenProps={this.screenProps}
                />
                <AppRoute
                  path={"/error"}
                  component={ErrorComponent}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  exact
                  path={"/health/frontend"}
                  component={FrontendHealthPage}
                  layout={EmptyLayout}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/view-profiles"}
                  component={ViewProfilesComponent}
                  layout={EmptyLayout}
                  screenProps={this.EmptyLayout}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/manage-profiles"}
                  component={ManageProfilesComponent}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/edit-profile/:id"}
                  component={EditProfilesComponent}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path={"/loader"}
                  component={LoaderComponent}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path={"/embed/:uniqueId"}
                  component={EmbedPlaybackPage}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />

                {/* TPG Scheduler — Admin module only; consumer SPA redirects away */}
                <AppRoute
                  path={"/scheduler"}
                  component={SchedulerAdminRedirect}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />

                {/* Phase C — Workspaces */}
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/workspace"}
                  component={WorkspaceHomePage}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/workspace/personal"}
                  component={PersonalWorkspacePage}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/workspace/creator"}
                  component={withStudioCapability(CreatorWorkspacePage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/workspace/creator/:creatorId"}
                  component={withStudioCapability(CreatorWorkspacePage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/workspace/organization"}
                  component={withStudioCapability(
                    OrganizationWorkspacePage,
                    "studio"
                  )}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/workspace/organization/:organizationId"}
                  component={withStudioCapability(
                    OrganizationWorkspacePage,
                    "studio"
                  )}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/workspace/project"}
                  component={withStudioCapability(ProjectWorkspacePage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/workspace/project/:projectId"}
                  component={withStudioCapability(ProjectWorkspacePage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/workspace/sales"}
                  component={SalesWorkspacePage}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/workspace/moderator"}
                  component={ModeratorWorkspacePage}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/workspace/subadmin"}
                  component={SubadminWorkspacePage}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/workspace/advertiser"}
                  component={AdvertiserWorkspacePage}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/workspace/partner"}
                  component={PartnerWorkspacePage}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />

                {/* Studio / Ops / Guide — authenticated + capability-gated (PR-001) */}
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/studio/timeline"}
                  component={withStudioCapability(TimelineStudioPage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/studio/calendar"}
                  component={withStudioCapability(TimelineStudioPage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/studio"}
                  component={withStudioCapability(StudioLandingPage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/studio/library"}
                  component={withStudioCapability(MediaLibraryPage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/studio/creator"}
                  component={withStudioCapability(CreatorStudioPage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/studio/creator/:creatorId"}
                  component={withStudioCapability(CreatorStudioPage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/studio/organization/:organizationId"}
                  component={withStudioCapability(
                    OrganizationStudioPage,
                    "studio"
                  )}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/studio/project/:projectId"}
                  component={withStudioCapability(ProjectStudioPage, "studio")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path={"/studio/advertising"}
                  component={AdvertisingAdminRedirect}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/studio/applications"}
                  component={withStudioCapability(
                    ApplicationsAdminPage,
                    "admin"
                  )}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/ops"}
                  component={withStudioCapability(BroadcastOpsPage, "ops")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/guide"}
                  component={GuidePage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/epg"}
                  component={withStudioCapability(EpgPage, "ops")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                {/*
                  Consumer Channel Detail must win over the ops Channel Directory.
                  /channels without exact was matching /channels/:slug and sending
                  viewers into the ops-gated directory (Access denied / admin UI).
                */}
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/channels/:slug"}
                  component={ChannelDetailPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  exact
                  path={"/channels"}
                  component={withStudioCapability(ChannelDirectoryPage, "ops")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/channel/:channelId/schedule"}
                  component={withStudioCapability(ChannelTunePage, "ops")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/channel/:channelId"}
                  component={withStudioCapability(ChannelTunePage, "ops")}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />

                <AppRoute
                  path={"/video/:id"}
                  component={PlaybackEntry}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />

                <AppRoute
                  path={"/v/:id"}
                  component={PlaybackEntry}
                  layout={EmptyLayout}
                  screenProps={this.eventEmitter}
                />

                {/* Experimental player lab — auth required; omitted from production builds unless flagged */}
                {(process.env.NODE_ENV !== "production" ||
                  process.env.REACT_APP_ENABLE_PLAYER_LAB === "1") && (
                  <React.Fragment>
                    <PrivateRoute
                      authentication={this.state.authentication}
                      path={"/player-lab"}
                      component={PlayerLabPage}
                      layout={EmptyLayout}
                      screenProps={this.eventEmitter}
                    />
                    <PrivateRoute
                      authentication={this.state.authentication}
                      path={"/video-player-preview"}
                      component={PlayerLabPage}
                      layout={EmptyLayout}
                      screenProps={this.eventEmitter}
                    />
                  </React.Fragment>
                )}

                {/***user layout - Having differnt header and footer ****/}
                {/* <AppRoute authentication={this.state.authentication} path={"/home"} component={Home} layout={UserLayout} screenProps={this.eventEmitter}/> */}

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/home"}
                  component={Home}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/account"}
                  component={AccountComponent}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/settings"}
                  component={AccountComponent}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/edit-account"}
                  component={EditAccountComponent}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/change-password"}
                  component={ChangePasswordComponent}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/referfriends"}
                  component={ReferalFriend}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/delete-account"}
                  component={DeleteAccountComponent}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/search"}
                  component={SearchComponent}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/subscription"}
                  component={SubscriptionComponent}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/billing-details"}
                  component={BillingDetailsComponent}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/billing-detail/view"}
                  component={BillingDetailsView}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/card-details"}
                  component={CardDetailsComponent}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/wishlist"}
                  component={Wishlist}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/category/:id"}
                  component={Category}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/invoice"}
                  component={InvoiceComponent}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/pay-per-view"}
                  component={PayPerView}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/payment-history"}
                  component={PaymentHistory}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/payment/view-details"}
                  component={PaymentViewDetails}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/payment-options"}
                  component={PaymentOptions}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/payment-success"}
                  component={PaymentSuccess}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/payment-failure"}
                  component={PaymentFailure}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/history"}
                  component={History}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/sub-category/:id?"}
                  component={SubCategory}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <Route exact path={"/home-banner"}>
                  <Redirect to="/home" />
                </Route>
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/donate/:entityType/:slug"}
                  component={EntityDonatePage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/donate"}
                  component={DonatePageEntry}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                {/***kids nested demos → assignment-driven /kids (Genres) ****/}

                <PrivateRoute
                  authentication={this.state.authentication}
                  path="/kids/home"
                  exact
                  component={() => <Redirect to="/kids" />}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path="/kids/originals"
                  component={() => <Redirect to="/kids" />}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path="/kids/characters"
                  component={() => <Redirect to="/kids" />}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <PrivateRoute
                  authentication={this.state.authentication}
                  path="/kids/category"
                  component={() => <Redirect to="/kids" />}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                {/***static layout - Having differnt header and footer ****/}

                {/* Legal documents (dynamic, DB-driven). Preserve legacy /page URLs. */}
                <Route
                  exact
                  path="/page/privacy"
                  render={() => <Redirect to="/privacy-policy" />}
                />
                <Route
                  exact
                  path="/page/terms"
                  render={() => <Redirect to="/terms" />}
                />
                <AppRoute
                  path="/fifty-fifty/:slug"
                  component={FiftyFiftyEventPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path="/fifty-fifty"
                  exact
                  component={FiftyFiftyEventPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path="/reverse-raffle/:slug"
                  component={ReverseRaffleEventPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path="/reverse-raffle"
                  exact
                  component={ReverseRaffleEventPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path="/film-festival/:slug"
                  component={FilmFestivalPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path="/film-festival"
                  exact
                  component={FilmFestivalPage}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                <AppRoute
                  path="/privacy-policy"
                  component={(props) => (
                    <LegalDocumentPage {...props} slug="privacy_policy" />
                  )}
                  layout={StaticLayout}
                  screenProps={this.eventEmitter}
                />
                <AppRoute
                  path="/terms"
                  component={(props) => (
                    <LegalDocumentPage {...props} slug="terms_of_service" />
                  )}
                  layout={StaticLayout}
                  screenProps={this.eventEmitter}
                />
                {/* Generic route — any future document works with no code change. */}
                <AppRoute
                  path="/legal/:slug"
                  component={LegalDocumentPage}
                  layout={StaticLayout}
                  screenProps={this.eventEmitter}
                />

                <AppRoute
                  path="/page/:id"
                  component={Page}
                  layout={StaticLayout}
                  screenProps={this.eventEmitter}
                />
                
                {/* StripeProvider must not be a pathless Switch child — it would
                    steal every unmatched route and block /:publicSlug (and /shop). */}
                <PrivateRoute
                  authentication={this.state.authentication}
                  path={"/add-card"}
                  exact
                  component={(props) => (
                    <StripeProvider
                      apiKey={configuration.get(
                        "configData.stripe_publishable_key"
                      )}
                    >
                      <Elements>
                        <AddCardComponent {...props} />
                      </Elements>
                    </StripeProvider>
                  )}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />

                {/* Configurable public browse slugs (white-label overrides). Keep after reserved routes. */}
                <PrivateRoute
                  authentication={this.state.authentication}
                  path="/:publicSlug"
                  exact
                  component={PublicBrowseGate}
                  layout={UserLayout}
                  screenProps={this.eventEmitter}
                />
        </Switch>
        </ExperiencePlatformGate>
      </Router>
    );

    return (
      <div>
        <MetaTags>
          <meta
              name="description"
              content={configuration.get("configData.meta_description")}
              ></meta>
            <meta
              name="keywords"
              content={configuration.get("configData.meta_keywords")}
              ></meta>
            <meta
              name="author"
              content={configuration.get("configData.meta_author")}
              ></meta>
            {this.state.adsenseVerificationMeta ? (
              <meta
                name="google-adsense-account"
                content={this.state.adsenseVerificationMeta}
              />
            ) : null}

            <meta property="og:title" content={configuration.get("configData.meta_title")} ></meta>
            <meta property="og:description" content={configuration.get("configData.meta_description")} ></meta>
            <meta property="og:image" content={configuration.get("configData.site_logo")} ></meta>

            <meta itemprop="name" content={configuration.get("configData.site_name")} ></meta>
            <meta itemprop="description" content={configuration.get("configData.meta_description")} ></meta>
            <meta itemprop="image" content={configuration.get("configData.site_logo")} ></meta>

            <meta property="twitter:card" content="summary_large_image" ></meta>
            <meta property="twitter:url" content={configuration.get("configData.twitter_link")} ></meta>
            <meta property="twitter:title" content={configuration.get("configData.meta_title")} ></meta>
            <meta property="twitter:description" content={configuration.get("configData.meta_description")} ></meta>
            <meta property="twitter:image" content={configuration.get("configData.site_logo")} ></meta>
        </MetaTags>
        <Helmet>
          <title>{configuration.get("configData.site_name")}</title>
          <link
            rel="icon"
            type="image/png"
            href={configuration.get("configData.site_icon")}
            sizes="16x16"
          />
          <link rel="apple-touch-icon" href={configuration.get("configData.site_icon")} />

          <link rel="apple-touch-icon" sizes="72x72" href={configuration.get("configData.site_icon")} />

          <link rel="apple-touch-icon" sizes="114x114" href={configuration.get("configData.site_icon")} />

          <link rel="apple-touch-icon" sizes="144x144" href={configuration.get("configData.site_icon")} />

        </Helmet>

          <ToastProvider placement="top-center">
            {googleClientId ? (
              <GoogleOAuthProvider clientId={googleClientId}>
                {appRouter}
              </GoogleOAuthProvider>
            ) : (
              appRouter
            )}
          </ToastProvider>

      </div>
    );
  }
}

export default ReactTimeout(App);
